<template>
  <div class="search">
    <el-row>
      <el-form :inline="true" :model="formInline">
        <el-form-item v-for="(item, index) in formItemList" :key="index" :label="item.label">
          <el-input v-if="item.type == 'text'" v-model="formInline[item.code]" :placeholder="item.placeholder"></el-input>

          <el-select v-if="item.type == 'select'" :multiple="item.multiple" v-model="formInline[item.code]" :placeholder="item.placeholder">
            <el-option
                v-for="itemIn in item.list"
                :key="itemIn.value"
                :label="itemIn.label"
                :value="itemIn.value">
            </el-option>
          </el-select>

          <el-date-picker
              v-if="item.type == 'date'"
              :type="item.dateType"
              v-model="formInline[item.code]"
              :value-format="item.dateFormat"
          ></el-date-picker>

        </el-form-item>
        <el-form-item>
          <slot name="opera"></slot>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "tableSearch",
  props: ['formInline', 'formItemList'],
  data() {
    return {

    }
  },
  methods: {
    onSubmit() {

    }
  }
}
</script>

<style scoped>
  .search {

  }
</style>